"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.path = exports.requestSchema = exports.walnutBlightRPV = exports.soilFavoriteDepths = exports.plantStress = exports.soilMAD = exports.kcSemiosModel = exports.kcOrganizationModels = exports.kcBlockSettings = exports.insectBiofix = exports.fireBlight = exports.bloom = exports.alternariaDSV = exports.almondHullSplit = void 0;
const zod_1 = require("zod");
const almondHullSplit_1 = require("./almondHullSplit/almondHullSplit");
const alternariaDSV_1 = require("./alternariaDSV/alternariaDSV");
const bloom_1 = require("./bloom/bloom");
const fireBlight_1 = require("./fireBlight/fireBlight");
const insectBiofix_1 = require("./insectBiofix/insectBiofix");
const kcBlockSettings_1 = require("./kcBlockSettings/kcBlockSettings");
const kcOrganizationModels_1 = require("./kcOrganizationModels/kcOrganizationModels");
const kcSemiosModel_1 = require("./kcSemiosModel/kcSemiosModel");
const soilMAD_1 = require("./MAD/soilMAD");
const plantStress_1 = require("./plantStress/plantStress");
const soilFavoriteDepths_1 = require("./soilFavoriteDepths/soilFavoriteDepths");
const walnutBlightRPV_1 = require("./walnutBlightRPV/walnutBlightRPV");
/* eslint-disable padding-line-between-statements */
exports.almondHullSplit = __importStar(require("./almondHullSplit/almondHullSplit"));
exports.alternariaDSV = __importStar(require("./alternariaDSV/alternariaDSV"));
exports.bloom = __importStar(require("./bloom/bloom"));
exports.fireBlight = __importStar(require("./fireBlight/fireBlight"));
exports.insectBiofix = __importStar(require("./insectBiofix/insectBiofix"));
exports.kcBlockSettings = __importStar(require("./kcBlockSettings/kcBlockSettings"));
exports.kcOrganizationModels = __importStar(require("./kcOrganizationModels/kcOrganizationModels"));
exports.kcSemiosModel = __importStar(require("./kcSemiosModel/kcSemiosModel"));
exports.soilMAD = __importStar(require("./MAD/soilMAD"));
exports.plantStress = __importStar(require("./plantStress/plantStress"));
exports.soilFavoriteDepths = __importStar(require("./soilFavoriteDepths/soilFavoriteDepths"));
exports.walnutBlightRPV = __importStar(require("./walnutBlightRPV/walnutBlightRPV"));
/* eslint-enable padding-line-between-statements */
exports.requestSchema = zod_1.z.object({
    almondHullSplit: almondHullSplit_1.requestSchema.optional(),
    alternariaDSV: alternariaDSV_1.requestSchema.optional(),
    bloom: bloom_1.requestSchema.optional(),
    fireBlight: fireBlight_1.requestSchema.optional(),
    insectBiofix: insectBiofix_1.requestSchema.optional(),
    kcBlockSettings: kcBlockSettings_1.requestSchema.optional(),
    kcOrganizationModels: kcOrganizationModels_1.requestSchema.optional(),
    kcSemiosModel: kcSemiosModel_1.requestSchema.optional(),
    plantStress: plantStress_1.requestSchema.optional(),
    soilFavoriteDepths: soilFavoriteDepths_1.requestSchema.optional(),
    soilMAD: soilMAD_1.requestSchema.optional(),
    walnutBlightRPV: walnutBlightRPV_1.requestSchema.optional(),
});
exports.path = '/field-asset-settings-get';
//# sourceMappingURL=index.js.map